import { GET_GATEWAY, LIST_GATEWAY } from "../actions/types";

const initialState = {
  gateway: null,
  gateways: {
    count: 0,
    rows: [],
  },
};

const applications = (state = initialState, action) => {
  switch (action.type) {
    case GET_GATEWAY:
      return {
        ...state,
        gateway: action.payload,
        gateways: initialState.gateways,
      };
    case LIST_GATEWAY:
      return {
        ...state,
        gateways: action.payload,
        gateway: initialState.gateway,
      };
    default:
      return state;
  }
};

export default applications;
